class NSSCarousel extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;

    this.videoSlideEls = this.querySelectorAll(`[nss-video-playing]`);
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Carousel] Connected.");

    this.initCarousel();

    this.addEventListener(`click`, (e) => {
      if (e.target.hasAttribute(`nss-video-playing`)) {
        if (e.target.getAttribute(`nss-video-playing`) === "false") {
          this.stopAllVideos();
          e.target.setAttribute(`nss-video-playing`, true);
          const videoEl = e.target.querySelector(`video`);
          videoEl.volume = 0.2;
          videoEl.muted = false;
          videoEl.play();
        } else {
          this.stopAllVideos();
        }
      }
    });

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ]
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  stopAllVideos() {
    this.videoSlideEls.forEach((videoSlideEl) => {
      const videoEl = videoSlideEl.querySelector(`video`);
      videoEl.pause();
      videoEl.muted = true;
      videoSlideEl.setAttribute(`nss-video-playing`, false);
    });
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);
    const settings = JSON.parse(this.querySelector(`#swiper-settings`).textContent);

    if (this.debug) console.log("[NSS][Carousel] settings:", settings);

    const presets = {
      a11y: {
        enabled: true,
      },
      navigation: {
        prevEl: '.nss-carousel-button-prev',
        nextEl: '.nss-carousel-button-next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      grabCursor: true,
    }

    const allSettings = Object.assign(presets, settings);
    if (this.debug) console.log("[NSS][Carousel] allSettings:", allSettings);

    this.swiper = new Swiper(carouselEl, allSettings);
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

    switch(e.type) {

      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;

    }
  }
}

let elementName = `nss-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCarousel);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}